import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=328593da&scoped=true&"
import script from "./EditProfile.vue?vue&type=script&lang=js&"
export * from "./EditProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=328593da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328593da",
  null
  
)

export default component.exports